<template>
  <div class="formWrapper mb-5">
    <div class="formWrapper__header">
      <Icon icon="delivery" class="formWrapper__header__icon" />
      <h3>Punkty dostaw</h3>
    </div>
    <div class="formWrapper__inner">
      <ValidationProvider
        name="deliveryPointsInputMode"
        rules="required"
        v-slot="{ errors }"
        tag="div"
        class="mb-4"
      >
        <div class="delivery-input-mode">
          <label class="radio-tile">
            <input
              id="delivery-points-manual"
              v-model="inputMode"
              type="radio"
              name="delivery-points-input-mode"
              value="manual"
            />
            <p class="radio-tile__title">
              Wprowadzam adresy manualnie
            </p>
            <p class="radio-tile__description">
              Opcja idealna dla małej liczby punktów dostaw.
            </p>
          </label>
          <label class="radio-tile">
            <input
              id="delivery-points-file"
              v-model="inputMode"
              type="radio"
              name="delivery-points-input-mode"
              value="file"
            />
            <p class="radio-tile__title">
              Wczytuję adresy z pliku
            </p>
            <p class="radio-tile__description">
              Opcja wygodniejsza kiedy masz wiele punktów dostaw.
            </p>
          </label>
        </div>
        <ul class="errors">
          <li class="text-danger" v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </ValidationProvider>
      <div v-if="inputMode === 'file'">
        <delivery-points-file-form />
      </div>
      <div v-if="inputMode === 'manual'">
        <delivery-points-number-form />
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Icon from '@/components/Icon.vue';
import DeliveryPointsNumberForm from './DeliveryPointsNumberForm.vue';
import DeliveryPointsFileForm from './DeliveryPointsFileForm.vue';

export default {
  name: 'DeliveryPointsInputModeForm',
  components: {
    Icon,
    DeliveryPointsNumberForm,
    DeliveryPointsFileForm,
  },
  computed: {
    ...mapFields('delivery', ['inputMode']),
  },
};
</script>

<style lang="scss" scoped>
.delivery-input-mode {
  display: flex;
  gap: 0.8rem;
  flex-direction: column;

  > * {
    flex: 1;
  }

  @media (min-width: 1200px) {
    flex-direction: row;
    gap: 1.6rem;
  }
}
</style>
